import React from 'react';
import iWillLogoWhite from '../../assets/iWillLogoWhite.png';
import Button from 'components/Form/Button';
import { InfoModal } from './InfoModal';

type Props = {
  title?: string;
  content: string;
  actionText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
};

export default function ConfirmModal({
  title,
  content,
  actionText,
  cancelText,
  onConfirm,
  onCancel,
  isSubmitting
}: Props) {
  return (
    <InfoModal width="md:w-[40%] sm:w-[30%]" className="h-fit rounded-md pb-5">
      <div className="flex flex-col items-center justify-between rounded-lg bg-white font-circular text-2xl font-bold text-[#353535]">
        <div className="flex w-full items-center gap-4 rounded-t bg-primary-900 p-2">
          <img src={iWillLogoWhite} className="h-10 w-20" />{' '}
          <p className="border-l-2 pl-3 text-base text-white">{title}</p>
        </div>
        <div className="px-8">
          <p className="mt-5 text-base">{content}</p>
          <div className="my-3 mt-10 flex items-center justify-end gap-3">
            <Button
              variant="outline"
              size="md"
              className="w-[10rem] rounded px-[1.5rem] py-1 text-sm font-normal"
              label={cancelText || 'No'}
              onClick={onCancel}
              disabled={isSubmitting}
              loading={isSubmitting}
            ></Button>
            <Button
              variant="primary"
              size="sm"
              className="w-[10rem] rounded px-[1.5rem] py-1 text-sm font-normal"
              label={actionText || 'Yes'}
              onClick={onConfirm}
              disabled={isSubmitting}
              loading={isSubmitting}
            ></Button>
          </div>
        </div>
      </div>
    </InfoModal>
  );
}
